"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const makeStyles_1 = __importDefault(require("@material-ui/styles/makeStyles"));
const CachingDataService_1 = __importStar(require("../../services/data/CachingDataService"));
const blobFunctions_1 = require("../../utils/blobFunctions");
exports.default = react_1.default.memo(FileContent);
const useStyles = makeStyles_1.default((theme) => ({
    link: {
        padding: "10px 9px",
        fontSize: 14,
        lineHeight: 1,
        textDecoration: "none",
        display: "flex",
        alignItems: "center"
    },
    icon: {
        backgroundImage: "url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAAA8CAYAAADL94L/AAAByElEQVR4Ae3axdJTQRAFYFyegA3u8ALseCDcicsGhxt3x+G32BXc3X3NBnfXYTqp3sZlhuqpOlXZRL46He9ReJyJxGSTEreaPfEHZiX+1uSJvelVNu+Jvjd7Yk9zI8aSUe0eDpjCIYfNSuw5v/zF5In/6mU27478tXriLJvXjdSwPq1lCDTCmxjiCNav8GZYBVMwWKagX8kWjk9vCcMhYWhEFEw1+oV0wZjdPKY6Vn9EwmBDTYPwBoXCYPLGDQTJjkHQNQRJj0FQtmgs+C8wOHIIkh2DoDu5vD5Xfkz9hsTBWDyxhjDYUDqvLRYSY1JilSQGyyxXOt4QKJPX70NDQmI27gyxHcn9bH/5RFMNAUgoDI4afOAMHBiCdiDNj5woGAhgsCEYudSI1lBCRwoPL957slAoDDYEoPXb/ZVs3FE/y9072fDxsx4BMPVfGOpl1VY/y5++4EWM1Fm9LcCKpy8RpnchDGEIQxjCEIYwhCEMYQhDGMIQhjCEIQxhCEMYwhCGMIQhDGEIQxhYNlXiP+XHXLRDM5thQVpyzIfS2YtLceVEkRmzalsgMArPhp258bA6b/LEb8LqPM930VNdvY/fhMmCxw+Of+4BTcPInBo2AAAAAElFTkSuQmCC)",
        backgroundSize: "contain",
        width: 26,
        height: 30
    },
    fileName: {
        flex: "1 0 auto",
        marginLeft: 8,
        color: props => props.sentByMe ? theme.colors.messageSentByMe.textColor : theme.colors.messageSentByElse.textColor
    }
}));
function FileContent(props) {
    const classes = useStyles(props);
    const content = props.content;
    let downloading = false;
    let title = content.blobDeleted ? `"${content.name}" no longer available` : `Download "${content.name}"`;
    let name = content.blobDeleted ? `${content.name} no longer available` : content.name;
    return (react_1.default.createElement("a", { className: classes.link, href: "#", role: "button", onClick: onClick, title: title },
        react_1.default.createElement("div", { className: classes.icon }),
        react_1.default.createElement("div", { className: classes.fileName }, name)));
    function onClick(e) {
        return __awaiter(this, void 0, void 0, function* () {
            if (content.blobDeleted) {
                return;
            }
            const anchor = findAnchor(e.target);
            const href = anchor.getAttribute("href");
            // If the file is already downloading or the anchor is now pointing at the blob then return
            if (downloading || href && href.startsWith("blob")) {
                return;
            }
            // Get the file from the IC
            downloading = true;
            const result = yield CachingDataService_1.default.getData(CachingDataService_1.DataSource.FileMessage, content.id, content.size, content.chunkSize);
            downloading = false;
            if (result.kind !== "success") {
                return;
            }
            // Point anchor at blob and re-click it to trigger download
            const blobUrl = blobFunctions_1.dataToBlobUrl(result.data, content.mimeType);
            anchor.setAttribute("href", blobUrl);
            anchor.setAttribute("download", content.name);
            anchor.click();
            // Reset anchor back to initial state and remove the blob from memory
            URL.revokeObjectURL(anchor.href);
            anchor.removeAttribute("download");
            anchor.setAttribute("href", "#");
        });
    }
    function findAnchor(node) {
        while (node != null && !(node instanceof HTMLAnchorElement)) {
            node = node.parentNode;
        }
        return node;
    }
}
